import { Link } from 'react-router-dom';
import { features } from '@/mocks/features';

export default function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-24 mt-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-800 text-sm font-medium rounded-full mb-4">
            <i className="ri-star-line mr-1"></i>
            核心功能
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            为什么选择爱液视频？
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl mx-auto">
            六大核心功能，从内容到体验，全方位满足您的观影需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="group bg-background-100 rounded-xl p-6 md:p-8 hover:bg-background-200/70 transition-all duration-300 cursor-pointer animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div
                className={`w-14 h-14 flex items-center justify-center rounded-xl mb-5 ${
                  feature.color === 'primary'
                    ? 'bg-primary-100 text-primary-600'
                    : feature.color === 'accent'
                    ? 'bg-accent-100 text-accent-700'
                    : 'bg-secondary-100 text-secondary-700'
                }`}
              >
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-3">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}